import { useMemo } from 'react';
import { useAnalyticsContext } from 'app/modules/analytics/context/AnalyticsContext';
import { useAnalyticsScope } from 'app/modules/analytics/context/AnalyticsScopeContext';
import { useAnalyticsFiltersStore } from 'app/modules/analytics/store/analyticsFiltersStore';
import {
  AnalyticsQueryDescriptor,
  buildAnalyticsQueryDescriptor,
} from 'app/modules/analytics/utils/analyticsQueryDescriptor';

export function useAnalyticsQueryDescriptor(): AnalyticsQueryDescriptor {
  const scope = useAnalyticsScope();
  const { isGroupSelected, enabledGroupPageIds, selectedPage, timezone } =
    useAnalyticsContext();
  const startDate = useAnalyticsFiltersStore((state) => state.startDate);
  const endDate = useAnalyticsFiltersStore((state) => state.endDate);
  const isComparisonEnabled = useAnalyticsFiltersStore(
    (state) => state.isComparisonEnabled,
  );
  const comparisonStartDate = useAnalyticsFiltersStore(
    (state) => state.comparisonStartDate,
  );
  const comparisonEndDate = useAnalyticsFiltersStore(
    (state) => state.comparisonEndDate,
  );

  const descriptor = buildAnalyticsQueryDescriptor({
    scopedPageIds: scope?.pageIds ?? null,
    isGroupSelected,
    enabledGroupPageIds,
    selectedPageId: selectedPage?.id ?? null,
    startDate,
    endDate,
    timezone,
    isComparisonEnabled,
    comparisonStartDate,
    comparisonEndDate,
  });

  const identity = JSON.stringify(descriptor);

  // Serialised identity keeps the descriptor referentially stable across
  // renders, so query keys and effect dependencies do not churn.
  // eslint-disable-next-line react-hooks/exhaustive-deps -- stable when serialised value matches
  return useMemo(() => descriptor, [identity]);
}
